module.exports={close:"Закрити",error:"Помилка",info:"Інформація",success:"Успішно",warning:"Попередження"};